import { ABFRAGEN_FOR_ABMUSTERUNG_QS, ABGESCHLOSSEN, WARTE_AUF_KUNDE } from '@/constants/werkzeugverwaltung/abmusterung/status';
import { unterschriftQsDate as unterschriftQsDateField, kundenfreigabeAngefragtDate as kundenfreigabeAngefragtDateField } from '@/config/abmusterung/abmusterungListFields';
import { REPARATUR } from '@/constants/werkzeugverwaltung/abmusterung/grund';

export default [
  {
    path: 'abmusterung',
    component: () => import('@/layouts/abmusterung/AbmusterungLayout.vue'),
    children: [
      {
        name: 'abmusterung',
        path: '',
        component: () => import('@/views/abmusterung/AbmusterungStartseite.vue'),
      },
      {
        path: 'list',
        name: 'abmusterung.list',
        component: () => import('@/views/abmusterung/AbmusterungListe.vue'),
        props: {
          archiv: false,
          abteilungId: null,
          statusId: null,
        },
      },
      {
        path: 'list/archiv',
        name: 'abmusterung.list.archiv',
        component: () => import('@/views/abmusterung/AbmusterungListe.vue'),
        props: {
          archiv: true,
          abteilungId: null,
          statusId: ABGESCHLOSSEN,
        },
      },
      {
        path: 'list/offen',
        name: 'abmusterung.list.offen',
        component: () => import('@/views/abmusterung/AbmusterungListe.vue'),
        props: {
          archiv: false,
          offen: true,
          abteilungId: null,
          notStatusId: ABGESCHLOSSEN,
        },
      },
      {
        path: 'list/status/qs',
        name: 'abmusterung.list.status.qs',
        component: () => import('@/views/abmusterung/AbmusterungListe.vue'),
        props: () => ({
          archiv: false,
          statusId: ABFRAGEN_FOR_ABMUSTERUNG_QS,
        }),
      },
      {
        path: 'list/status/wartet-auf-kunde',
        name: 'abmusterung.list.status.wartet_auf_kunde',
        component: () => import('@/views/abmusterung/AbmusterungListe.vue'),
        props: () => ({
          archiv: false,
          statusId: WARTE_AUF_KUNDE,
        }),
      },
      {
        path: 'list/status/:status',
        name: 'abmusterung.list.status',
        component: () => import('@/views/abmusterung/AbmusterungListe.vue'),
        props: (route) => ({
          archiv: false,
          statusId: route.params.status,
        }),
      },
      {
        path: 'list/abteilung/:abteilung',
        name: 'abmusterung.list.abteilung',
        component: () => import('@/views/abmusterung/AbmusterungListe.vue'),
        props: (route) => ({
          archiv: false,
          abteilungId: route.params.abteilung,
        }),
      },
      {
        path: 'list/grund/reparatur',
        name: 'abmusterung.list.grund.reparatur',
        component: () => import('@/views/abmusterung/AbmusterungListe.vue'),
        props: () => ({
          archiv: false,
          grundId: REPARATUR,
          notStatusId: ABGESCHLOSSEN,
        }),
      },
      {
        path: 'list/grund/:grund',
        name: 'abmusterung.list.grund',
        component: () => import('@/views/abmusterung/AbmusterungListe.vue'),
        props: (route) => ({
          archiv: false,
          grundId: route.params.grund,
          notStatusId: ABGESCHLOSSEN,
        }),
      },
      {
        path: 'list/abteilung/:abteilung/status/kundenfreigabe_ueberfaellig',
        name: 'abmusterung.list.abteilung.kundenfreigabe_ueberfaellig',
        component: () => import('@/views/abmusterung/AbmusterungListe.vue'),
        props: (route) => {
          const { abteilung } = route.params;
          const additionalFields = [];
          additionalFields.push(unterschriftQsDateField);
          additionalFields.push(kundenfreigabeAngefragtDateField);
          return {
            archiv: false,
            abteilungId: abteilung,
            statusId: WARTE_AUF_KUNDE,
            additionalFields,
            kundenfreigabeUeberfaellig: true,
          };
        },
      },
      {
        path: 'list/abteilung/:abteilung/status/:status',
        name: 'abmusterung.list.abteilung.status',
        component: () => import('@/views/abmusterung/AbmusterungListe.vue'),
        props: (route) => {
          const { status, abteilung } = route.params;
          const additionalFields = [];

          if (status === WARTE_AUF_KUNDE) {
            additionalFields.push(unterschriftQsDateField);
          }

          return {
            archiv: false,
            abteilungId: abteilung,
            statusId: status,
            additionalFields,
          };
        },
      },
      {
        path: 'neu/:abteilung',
        name: 'abmusterung.neu.abteilung',
        component: () => import('@/views/abmusterung/Abmusterung.vue'),
        props: (route) => ({
          edit: true,
          abteilungId: route.params.abteilung,
        }),
      },
      {
        path: 'neu/:abteilung/:tab',
        name: 'abmusterung.neu.abteilung.tab',
        component: () => import('@/views/abmusterung/Abmusterung.vue'),
        props: (route) => ({
          edit: true,
          abteilungId: route.params.abteilung,
          tab: route.params.tab,
        }),
      },
      {
        path: ':id',
        name: 'abmusterung.id',
        component: () => import('@/views/abmusterung/Abmusterung.vue'),
        props: (route) => ({
          id: route.params.id,
          edit: false,
          tab: null,
        }),
      },
      {
        path: ':id/edit',
        name: 'abmusterung.id.edit',
        component: () => import('@/views/abmusterung/Abmusterung.vue'),
        props: (route) => ({
          id: route.params.id,
          edit: true,
          tab: null,
        }),
      },
      {
        path: ':id/:tab',
        name: 'abmusterung.id.tab',
        component: () => import('@/views/abmusterung/Abmusterung.vue'),
        props: (route) => ({
          id: route.params.id,
          edit: false,
          tab: route.params.tab,
        }),
      },

      {
        path: ':id/edit/:tab',
        name: 'abmusterung.id.edit.tab',
        component: () => import('@/views/abmusterung/Abmusterung.vue'),
        props: (route) => ({
          id: route.params.id,
          edit: true,
          tab: route.params.tab,
        }),
      },
    ],
  },
];
